var _browserCheck = {
	isChrome: function() {
		var chrome = /Chrome/.test(navigator.userAgent) && /Google/.test(navigator.vendor);
		return chrome;
	},
	isSafari: function() {
		var safari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
		return safari;
	},
	isFirefox: function() {
		var firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
		return firefox;
	},
	isIE: function() {
		var ua = window.navigator.userAgent;
		var IE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1 || ua.indexOf('Edge/') > -1;
		return IE;
	},
	isIEVersion: function() {
		if (_browserCheck.isIE() == true) {
			var ua = window.navigator.userAgent;
		  var msie = ua.indexOf("MSIE ");
			var edge = ua.indexOf('Edge/');

	    if (navigator.userAgent.match(/Trident.*rv\:11\./)) {
	    	return 11;
	    } else {
	    	msie = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)))
	    	return msie;
	    }

			if (edge > 0) {
				edge = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
				return edge;
			}

		} else {
			return false;
		}
	},
	isEdge: function() {
		var edge = navigator.userAgent.toLowerCase().indexOf('edge') > -1;
		return edge;
	},
	isIOS: function() {
		var isTouch = Modernizr.touchevents,
			iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isTouch == true && iOS == true) {
			return true;
		} else {
			return false;
		}
	},
	isIosTablet: function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(min-width: 768px) and (max-width: 1439px)"),
				iOS = checks.isIOS();
			if (isTabletWidth.matches && iOS == true) {
				return true;
			} else {
				return false;
			}
		}
	},
	isIosPhone: function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(max-width: 767px)"),
				iOS = checks.isIOS();
			if (isTabletWidth.matches && iOS == true) {
				return true;
			} else {
				return false;
			}
		}
	},
	isAndroid: function() {
		var isTouch = Modernizr.touchevents,
			android = /android/.test(navigator.userAgent.toLowerCase()) && !window.MSStream;
		if (isTouch == true && android == true) {
			return true;
		} else {
			return false;
		}
	},
	isAndroidTablet: function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(min-width: 768px) and (max-width: 1439px)"),
				android = checks.isAndroid();
			if (isTabletWidth.matches && android == true) {
				return true;
			} else {
				return false;
			}
		}
	},
	isAndroidPhone: function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(max-width: 767px)"),
				android = checks.isAndroid();
			if (isTabletWidth.matches && android == true) {
				return true;
			} else {
				return false;
			}
		}
	},
	isWindowsCE: function() {
		var isTouch = Modernizr.touchevents,
			windowsCE = false;
		if(navigator.userAgent.match(/Windows Phone/i)){ windowsCE = true; }
		if(navigator.userAgent.match(/iemobile/i)){ windowsCE = true; }
		if(navigator.userAgent.match(/WPDesktop/i)){ windowsCE = true; }
		if (isTouch == true && windowsCE == true) {
			return true;
		} else {
			return false;
		}
	},
	isWindowsCETablet: function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(min-width: 768px) and (max-width: 1439px)"),
				windows = checks.isWindowsCE();
			if (isTabletWidth.matches && windows == true) {
				return true;
			} else {
				return false;
			}
		}
	},
	isWindowsCEPhone: function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(max-width: 767px)"),
				windows = checks.isWindowsCE();
			if (isTabletWidth.matches && windows == true) {
				return true;
			} else {
				return false;
			}
		}
	},
	isMobile:function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(max-width: 767px)");
			if (isTabletWidth.matches && (_browserCheck.isIOS() == true || _browserCheck.isAndroid() == true || _browserCheck.isWindowsCE() == true)) {
				return true;
			} else {
				return false;
			}
		}
	},
	isTablet:function() {
		if (window.matchMedia) {
			var isTabletWidth = window.matchMedia("(min-width: 768px) and (max-width: 1439px)");
			if (isTabletWidth.matches && (_browserCheck.isIOS() == true || _browserCheck.isAndroid() == true || _browserCheck.isWindowsCE() == true)) {
				return true;
			} else {
				return false;
			}
		}
	}
}
